import React, { PropsWithRef, forwardRef, useState } from 'react';
import { Input } from '@vtbhome/juicyfront';
import { AllEyeClose, AllEyeOpen, StyledFormGroup } from './input-password.styles';
import { AllLock } from '@vtbhome/juicyfront/indexIcon';
import { InputPasswordProps } from './types';
import { useInputAutocomplete } from '@shared/lib/hooks/use-input-autocomplete/use-input-autocomplete';
import { mergeRefs } from '@shared/lib/utils/merge-refs/merge-refs';
import { ErrorMessageInput } from '../error-message-input/error-message-input';

export const InputPassword = forwardRef(
    (
        { label, error, hint, autoComplete, ...props }: PropsWithRef<InputPasswordProps>,
        ref: React.Ref<HTMLLabelElement | null>
    ) => {
        const inputRef = useInputAutocomplete(autoComplete);
        const [displayPassword, setDisplayPassword] = useState(false);

        return (
            <StyledFormGroup
                $error={error}
                label={label}
                required={props.required}
                errorMessage={<ErrorMessageInput error={error} hint={hint} />}>
                <Input
                    ref={mergeRefs(ref, inputRef)}
                    startAdornment={<AllLock />}
                    type={displayPassword ? 'text' : 'password'}
                    endAdornment={
                        displayPassword ? (
                            <AllEyeOpen onClick={() => setDisplayPassword((prev) => !prev)} />
                        ) : (
                            <AllEyeClose onClick={() => setDisplayPassword((prev) => !prev)} />
                        )
                    }
                    invalid={Boolean(error)}
                    {...props}
                />
            </StyledFormGroup>
        );
    }
);

InputPassword.displayName = 'InputPassword';
